import { render, staticRenderFns } from "./CheckAccess.vue?vue&type=template&id=40a392ab&scoped=true"
import script from "./CheckAccess.vue?vue&type=script&lang=ts"
export * from "./CheckAccess.vue?vue&type=script&lang=ts"
import style0 from "./CheckAccess.vue?vue&type=style&index=0&id=40a392ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a392ab",
  null
  
)

export default component.exports